import { useCalendarData } from "@chef/state-management/hooks";
import { CalendarQuery } from "@chef/state-management";

import { Groceries } from "../shared/Groceries";

interface CalendarWeekGroceriesProps {
  calendarWeek: CalendarQuery["calendar"][number];
  initiallyExpanded?: boolean;
}

export const CalendarWeekGroceries = ({
  calendarWeek: { week, year },
  initiallyExpanded,
}: CalendarWeekGroceriesProps) => {
  const {
    basket: { groceryBasket },
  } = useCalendarData({
    week,
    year,
  });

  return (
    <Groceries
      groceries={groceryBasket.map((grocery) => ({
        name: grocery.name || "",
        quantity: grocery.quantity,
        price: grocery.price * grocery.quantity,
      }))}
      initiallyExpanded={initiallyExpanded}
    />
  );
};
